<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <!-- <el-col :span="4" :xs="24">
          <el-form-item prop="agentId">
            <el-select
              v-model="params.agentId"
              :loading="loading"
              :remote-method="remoteMethod"
              filterable
              placeholder="请输入运营商姓名"
              remote
              reserve-keyword
            >
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="4" :xs="12">
          <el-form-item prop="cardId">
            <el-input
              v-model="params.cardId"
              maxlength="8"
              placeholder="输入卡片编号查询"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4" :xs="12">
          <el-form-item prop="phone">
            <el-input
              v-model="params.phone"
              maxlength="11"
              placeholder="输入手机号码查询"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="12">
          <el-form-item prop="name">
            <el-input v-model="params.name" placeholder="输入姓名查询" />
          </el-form-item>
        </el-col> -->
        <el-col :span="2" :xs="6">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <!-- <el-row>
      <el-button plain type="success" @click="setCardList"
        >批量设置射频卡</el-button
      >
    </el-row> -->
    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column type="selection" width="55" /> -->
      <el-table-column label="卡片编号" width="100">
        <template slot-scope="scope">
          <!-- class="click"
          @click="skip(scope.row.cardId, scope.row.id)"
          -->
          <span>
            {{ scope.row.cardId.padStart(8, "0") }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        :formatter="formatterPhone"
        label="手机号码"
        prop="phone"
        width="120"
      /> -->

      <el-table-column label="车辆编号">
        <template slot-scope="scope">
          <span class="click" @click="skip(scope.row.memberCar.id)">
            {{ scope.row.memberCar && scope.row.memberCar.id }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="车辆编号" prop="memberCar.id" /> -->
      <!-- <el-table-column label="车牌号码" prop="memberCar.plateNumber" /> -->
      <!-- <el-table-column label="用户类型" prop="memberType" width="100">
        <template slot-scope="scope">
          {{
            scope.row.memberType == "1"
              ? "微信"
              : scope.row.memberType == "7"
              ? "支付宝"
              : ""
          }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        :formatter="formatterCardName"
        label="用户姓名"
        prop="name"
        width="100"
      />

      <el-table-column
        :formatter="formatterSum"
        label="余额"
        prop="money"
        width="100"
      />
      <el-table-column
        :formatter="formatterSum"
        label="豆币"
        prop="token"
        width="100"
      /> -->
      <el-table-column label="状态">
        <template slot-scope="scope">
          <template v-if="scope.row.state == '1'">
            {{ scope.row.carId ? "已绑定" : "未绑定" }}
          </template>
          <template v-if="scope.row.state == '-1'"> 已禁用 </template>
        </template>
      </el-table-column>
      <el-table-column label="运营商" prop="agent.name" />
      <el-table-column label="操作" width="400">
        <template slot-scope="scope">
          <template v-if="scope.row.state == '-1'">
            <el-button size="mini" @click="activate(scope.row.id)"
              >激活</el-button
            >
          </template>

          <template v-if="scope.row.state == '1'">
            <el-button
              v-if="scope.row.carId"
              size="mini"
              type="warning"
              @click="
                () => {
                  deleteId = scope.row.id;
                  unbindDialog = true;
                }
              "
            >
              解绑
            </el-button>
            <!-- <template v-else >
              <el-button size="mini" @click="bind(scope.row.id)"
                >绑定</el-button
              >
            </template> -->

            <el-button size="mini" type="danger" @click="disabled(scope.row.id)"
              >禁用</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <page :current="current" :size="size" :total="total" />
    </div>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="bindDialog"
      title="绑定"
      width="20%"
    >
      <el-form :model="bindForm" label-width="auto">
        <el-form-item label="姓名">
          <el-input v-model="bindForm.name" placeholder="姓名" />
        </el-form-item>
        <!-- <el-form-item label="电话">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-input v-model.number="bindForm.phone" placeholder="电话" />
            </el-col>
          </el-row>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button @click="bindDialog = false">取 消</el-button>
        <el-button type="primary" @click="binding">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="shiftDialog"
      title="转移"
    >
      <el-form
        ref="shift"
        :model="shiftParams"
        :rules="rules"
        class="demo-form-inline"
        label-width="auto"
      >
        <el-form-item label="转移编号" prop="newCardNum">
          <el-input v-model="shiftParams.newCardNum" placeholder="转移编号" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="shiftDialog = false">取 消</el-button>
        <el-button type="primary" @click="shiftGet">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="unbindDialog"
      title="解绑"
    >
      <div style="text-align: center; font-size: 30px">
        <i class="el-icon-warning" />
        <span style="text-align: center">确定解绑射频卡？</span>
      </div>
      <div slot="footer">
        <el-button @click="unbindDialog = false">取 消</el-button>
        <el-button type="primary" @click="unbind">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="addMoney"
      title="射频卡充值"
    >
      <el-form :model="addMoneyForm" label-width="auto">
        <el-form-item label="卡号">
          {{ chooseCard.cardId }}
        </el-form-item>
        <el-form-item label="用户手机号">
          {{ chooseCard.phone }}
        </el-form-item>
        <el-form-item label="充值金额">
          <el-input v-model="addMoneyForm.money" placeholder="请输充值金额" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addMoney = false">取消</el-button>
        <el-button type="primary" @click="addGet">确定</el-button>
      </div>
    </el-dialog> -->

    <!-- <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="refundMoney"
      title="射频卡退款"
    >
      <el-form :model="addMoneyForm" label-width="auto">
        <el-form-item label="用户编号">
          {{ chooseCard.cardId }}
        </el-form-item>
        <el-form-item label="用户手机号">
          {{ chooseCard.phone }}
        </el-form-item>
        <el-form-item label="退款类型">
          <el-radio-group v-model="refundMoneyType">
            <el-radio-button label="0">余额</el-radio-button>
            <el-radio-button label="1">豆币</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input v-model="addMoneyForm.money" placeholder="退款金额" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="refundMoney = false">取消</el-button>
        <el-button type="primary" @click="refundMoneyPost">确定</el-button>
      </div>
    </el-dialog> -->
    <!-- <BatchSetCardDialog :dialog="BatchSetCardDialog" :list="selectList" /> -->
  </div>
</template>

<script>
// import adminBindCardForWeChat from "@/api/user/card-manage/adminBindCardForWeChat";
// import adminCancelsCardLossReporting from "@/api/user/card-manage/adminCancelsCardLossReporting";
// import adminChangeCard from "@/api/user/card-manage/adminChangeCard";
// import adminChargeMoney from "@/api/user/card-manage/adminChargeMoney";
import agentDisableRfIdCard from "@/api/user/card-manage/agentDisableRfIdCard";
import agentEnableRfIdCard from "@/api/user/card-manage/agentEnableRfIdCard";
import agentGetRFIDCardListByCarIdList from "@/api/user/card-manage/agentGetRFIDCardListByCarIdList";
import agentUnBindRFIDCard from "@/api/user/card-manage/agentUnBindRFIDCard";
// import adminRefundCardMoney from "@/api/user/card-manage/adminRefundCardMoney";
// import adminRefundCardToken from "@/api/user/card-manage/adminRefundCardToken";
// import adminToReportTheLossOfCard from "@/api/user/card-manage/adminToReportTheLossOfCard";
// import adminGetWeChatUserByPhone from "@/api/user/we-chat-user-manage/adminGetWeChatUserByPhone";
import Page from "@/components/Page";
import createdMixin from "@/mixin/createdMixin";
import dialogMixin from "@/mixin/dialogMixin";
import formatterSumMixin from "@/mixin/formatterMixin";
// import getAgentMixin from "@/mixin/getAgentMixin";
import pageMixin from "@/mixin/pageMixin";
import resDispose from "@/mixin/resDisposeMixin";
import searchMixin from "@/mixin/searchMixin";
// import BatchSetCardDialog from "@/views/ElectricityCardManage/diolag/BatchSetCardDialog";
import { Message } from "element-ui";

export default {
  name: "RFCardManage",
  mixins: [
    pageMixin,
    dialogMixin,
    searchMixin,
    createdMixin,
    resDispose,
    // getAgentMixin,
    formatterSumMixin,
  ],
  components: {
    // BatchSetCardDialog,
    Page,
  },
  data: () => {
    return {
      addMoney: false,
      refundMoney: false,
      refundMoneyType: "0",
      addMoneyForm: {
        memberId: "",
        money: "",
      },
      chooseCard: {},
      phone: "",
      nickName: "",
      bindDialog: false,
      unbindDialog: false,
      shiftDialog: false,
      deleteId: undefined,
      loading: false,
      params: {
        id: undefined,
        agentId: undefined,
        cardId: undefined,
        number: undefined,
        name: undefined,
        phone: undefined,
      },
      rules: {
        newCardNum: [{ required: true, message: "请输入卡号" }],
      },
      bindForm: {
        cardId: undefined,
        phone: undefined,
        name: undefined,
        userId: undefined,
      },
      records: [],
      list: [],
      shiftParams: {
        oldCardId: undefined,
        newCardNum: undefined,
      },
      BatchSetCardDialog: false,
      selectList: [],
    };
  },
  methods: {
    setCardList() {
      if (this.selectList.length === 0) {
        Message({
          message: "请选择射频卡!",
          type: "warning",
          duration: 3 * 1000,
        });
      } else {
        this.BatchSetCardDialog = true;
      }
    },
    handleSelectionChange(val) {
      this.selectList = [];
      for (const key of val) {
        this.selectList.push(key.id);
      }
    },
    refund(id) {
      this.id = id;
      this.weRefundDialog = true;
    },
    searchCard() {
      // adminGetWeChatUserByPhone({
      //   phone: this.bindForm.phone,
      // }).then((res) => {
      //   this.list = res.data;
      // });
    },
    loss(id) {
      console.log(id);
      // adminToReportTheLossOfCard(id).then((res) => {
      //   this.resFetch({ res });
      // });
    },
    noLoss(id) {
      console.log(id);
      // adminCancelsCardLossReporting(id).then((res) => {
      //   this.resFetch({ res });
      // });
    },
    fetchData() {
      this.loadTable = true;
      if (!this.params.phone) {
        this.params.phone = undefined;
      }
      agentGetRFIDCardListByCarIdList({
        ...this.params,
        pageNum: this.current,
        size: this.size,
      })
        .then((res) => {
          console.log(res);
          this.total = res.data.total;
          this.records = res.data.records;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
    pay(scope) {
      this.addMoneyForm.memberId = scope.row.id;
      this.addMoneyForm.memberId = scope.row.id;
      this.nickName = scope.row.phone;
      this.addMoney = true;
      this.chooseCard = scope.row;
      console.log(scope.row);
    },
    refundMoneyClick(scope) {
      this.addMoneyForm.userId = scope.row.id;
      this.nickName = scope.row.phone;
      this.refundMoney = true;
      this.chooseCard = scope.row;
    },
    addGet() {
      // adminChargeMoney(this.addMoneyForm).then((res) => {
      //   this.resDispose({
      //     res,
      //     success: () => {
      //       this.fetchData();
      //       this.addMoney = false;
      //     },
      //   });
      // });
    },
    refundMoneyPost() {
      if (this.refundMoneyType === "0") {
        // adminRefundCardMoney({
        //   money: this.addMoneyForm.money,
        //   memberId: this.addMoneyForm.userId,
        // }).then((res) => {
        //   this.resDispose({
        //     res,
        //     success: () => {
        //       this.fetchData();
        //       this.addMoney = false;
        //     },
        //   });
        // });
      } else {
        // adminRefundCardToken({
        //   money: this.addMoneyForm.money,
        //   memberId: this.addMoneyForm.userId,
        // }).then((res) => {
        //   this.resDispose({
        //     res,
        //     success: () => {
        //       this.fetchData();
        //       this.addMoney = false;
        //     },
        //   });
        // });
      }
    },
    activate(id) {
      agentEnableRfIdCard(id).then((res) => {
        this.resDispose({
          res,
          success: () => {
            this.fetchData();
          },
        });
      });
    },
    disabled(id) {
      agentDisableRfIdCard(id).then((res) => {
        this.resDispose({
          res,
          success: () => {
            this.fetchData();
          },
        });
      });
    },
    bind(id) {
      this.bindForm.cardId = id;
      this.bindDialog = true;
    },
    binding() {
      // adminBindCardForWeChat(this.bindForm).then((res) => {
      //   this.resDispose({
      //     res,
      //     success: () => {
      //       this.bindDialog = false;
      //       this.fetchData();
      //     },
      //   });
      // });
    },
    unbind() {
      agentUnBindRFIDCard(this.deleteId).then((res) => {
        this.resDispose({
          res,
          success: () => {
            this.fetchData();
            this.unbindDialog = !this.unbindDialog;
          },
        });
      });
    },
    shift(row) {
      this.shiftDialog = !this.shiftDialog;
      this.shiftParams.oldCardId = row.id;
    },
    shiftGet() {
      this.$refs["shift"].validate((valid) => {
        if (valid) {
          // adminChangeCard(this.shiftParams).then((res) => {
          //   this.resDispose({
          //     res,
          //     success: () => {
          //       this.shiftDialog = !this.shiftDialog;
          //     },
          //   });
          // });
        }
      });
    },
    status(scope) {
      if (scope.row.status === 1) {
        scope.row.status = 2;
      } else {
        scope.row.status = 1;
      }
    },
    skip(carId) {
      this.$router.push({
        path: "/UserCar?id=" + carId,
      });
    },
  },
};
</script>
<style scoped>
.img {
  width: 30px;
  height: 30px;
}
</style>
